import React from 'react';
import { Link } from 'react-router-dom';
import {
  ATMButton,
  ATMGrid,
  ATMHeader,
  ATMPopover,
  ATMIcon,
} from 'shared-it-appmod-ui';
import Moment from 'src/libraries/moment.library';
import Lang from 'src/libraries/language';
import { getRequestUrl } from 'src/selectors/request.selector';
import { IRequestItem } from 'src/models/request.model';
import styles from '../flight-request-list.module.scss';

type IProps = {
  data: IRequestItem;
};

const FlightRequestListPopover: React.FC<IProps> = ({ data }) => {
  const url = getRequestUrl({
    request: {
      requestId: data.requestId,
      flightFlag:
        data?.flightCategory === 'Patrol/Passenger - SCG'
          ? 6
          : data.flightCategoryKey ?? 1,
    },
  });
  return (
    <>
      <ATMPopover
        trigger={
          <div className={styles.textLimit}>
            <div>
              <ATMIcon
                circular
                size="small"
                color={data.flightCategory?.includes('SCG') ? 'blue' : 'pink'}
                name={
                  // eslint-disable-next-line no-nested-ternary
                  data.flightCategory?.includes('Passenger')
                    ? 'plane'
                    : data.flightCategory?.includes('Construction')
                    ? 'wrench'
                    : 'servicestack'
                }
                style={{
                  boxShadow: data.flightCategory?.includes('SCG')
                    ? '0 0 0 0.08em rgb(33, 133, 208) inset'
                    : '0 0 0 0.08em rgb(224, 57, 151) inset',
                  marginRight: '0.75em',
                  fontSize: '1.15em',
                }}
              />
              <Link to={url}>
                <strong style={{ textDecoration: 'underline' }}>
                  {`${data.flightCategory} - ${data.requestId}`}
                </strong>
              </Link>
            </div>
          </div>
        }
        flowing
        hoverable
        position="right center"
        style={{
          borderTop: '4px solid #053388',
          minWidth: '300px',
        }}
        mouseLeaveDelay={250}
      >
        <div
          style={{
            color: '#009BD9',
            borderBottom: '1px solid rgba(34, 36, 38, 0.1)',
            marginBottom: '20px',
            paddingBottom: '10px',
          }}
        >
          <ATMGrid>
            <ATMGrid.Column style={{ width: 'fit-content' }}>
              <ATMHeader as="h3">
                <Link to={url}>
                  {`${data.flightCategory} - ${data.requestId}`}
                </Link>
              </ATMHeader>
            </ATMGrid.Column>
            <ATMGrid.Column floated="right">
              <ATMButton
                as={Link}
                to={url}
                icon="external alternate"
                style={{
                  marginLeft: '-15px',
                  padding: '0',
                }}
              />
            </ATMGrid.Column>
          </ATMGrid>
        </div>
        <ATMGrid>
          <ATMGrid.Row columns="equal">
            <ATMGrid.Column>
              <ATMHeader as="h3" content={Lang.LBL_OPERATOR} />
              {data.operatorName}
            </ATMGrid.Column>
            <ATMGrid.Column>
              <ATMHeader as="h3" content={Lang.LBL_REQUEST_DATE} />
              {Moment.utc(data.requestDate).format('MM/DD/YYYY')}
            </ATMGrid.Column>
          </ATMGrid.Row>
        </ATMGrid>
      </ATMPopover>
    </>
  );
};

export default FlightRequestListPopover;
